
define(
	'Ames.Searchspring.Searchspring'
,   [
	'Header.View'
	]
,   function (
		HeaderView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var environment = container.getComponent('Environment')
			
			var searchspringEnabled = environment.getConfig('Searchspring.Enabled') || false;

			var layout = container.getComponent('Layout');

			// SiteSearch.View
			layout.addToViewContextDefinition('SiteSearch.View', 'searchImplemented', 'boolean', function (context) {
				return searchspringEnabled;
			});

			_.extend(HeaderView.prototype, {
				showSiteSearch: _.wrap(HeaderView.prototype.showSiteSearch, function (fn) {
					// keep original init
					setTimeout(function () {
						// set focus on $('.itemssearcher-input')
						var $input = $('.itemssearcher-input');
						if ($input.length) {
							$input.focus();
						}
					}, 500);
					fn.apply(this, Array.prototype.slice.call(arguments, 1));
				})
			});


		}
	};
});
